<template>
  <div
    class="mt-2"
    style="max-width: 500px;"
  >
    <v-toolbar
      class="elevation-1 white--text"
      color="primary"
      height="50px"
    >
      <v-toolbar-title>
        <v-icon class="white--text">fa-th</v-icon>
        ECS Companies
      </v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      />
      <v-spacer />
      <AddEcsCompanyDialog />
      <EditEcsCompanyDialog />
    </v-toolbar>
    <v-data-table
      :headers="ecsCompanyTableHeaders"
      :items="ecsCompanyList"
      class="elevation-1"
      v-if="ecsCompanyList !== undefined"
    >
      <template
        slot="item"
        slot-scope="props"
      >
        <tr>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.isActive ? "Y" : "N" }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon
              @click="editItem(props.item)"
              class="mr-2"
              small
              style="display: inline-flex;"
            >
              edit
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {alphaNum, required} from 'vuelidate/lib/validators'
    import EditTableFunctions from './../../../components/editTableFunctions';
    import {LOAD_ECS_COMPANY_TO_EDIT, TOGGLE_EDIT_ECS_COMPANY_DIALOG} from "../../../store/ecs_company/mutations.js";
    import {FETCH_ECS_COMPANY_LIST} from "../../../store/ecs_company/actions.js";
    import EditEcsCompanyDialog from "./EditEcsCompanyDialog";
    import AddEcsCompanyDialog from "./AddEcsCompanyDialog";


    export default {

        validations: {
            ecsCompanyName: {required, alphaNum} // rules object
        },

        components: {
            AddEcsCompanyDialog,
            EditEcsCompanyDialog
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                dialog: false,
                breadcrumbPath: [{text: process.env.VUE_APP_SYSTEM_NAME, to: "/"}, {text: 'Manage Ecs Companies', disabled: true,}],
                loading: true,
                personnelWithEcsCompanyTitle: [],
                selectedPersonnelId: '',
                ecsCompanyId: '',
                chosenPerson: {},
                ecsCompanyTableHeaders: [
                    {
                        text: 'Name',
                        align: 'left',
                        value: 'name'
                    },
                    {
                        text: 'Is Live',
                        align: 'left',
                        value: 'isActive'
                    },
                    {text: 'Actions', align: 'center', value: 'name', sortable: false}
                ],
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
                idName: 'ecsCompanyId',
            };
        },

        computed: {
            ...mapGetters(
            [
                "ecsCompanyList",
            ]
            ),
            newEcsCompanyName: {
                get() {
                    return this.$store.state.ecsCompany.newEcsCompany.name;
                },
                set(value) {
                    this.updateValue('name', value);
                },
            },
        },

        mounted() {
            this.fetchAllTableItems();

            if (
            this.$route.params !== undefined
            && this.$route.params.ecsCompanyId !== undefined) {
                this.ecsCompanyId = this.$route.params.ecsCompanyId;

            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_ECS_COMPANY_LIST,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_ECS_COMPANY_DIALOG,
                loadTableItemToEdit: LOAD_ECS_COMPANY_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
  #ecsCompanyTable {
    width: 100%;
    text-align: left;
    padding-left: 16px;
  }

  #ecsCompanyTable th,
  #ecsCompanyTable td {
    text-align: left;
  }
</style>
